// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import VueTianditu from "vue-tianditu";
// 引入路由
import router,{resetRouter} from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
//
// 富文本相关
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import {
  post,
  get,
  put,
  deletes,
  patch,
  toJson,
  isEmpty,
  uploadImg
} from './utils/http.js' // 请求方式中间件
import {
  api,
  baseUrl
} from './utils/api.js' // API 链接
import VueParticles from 'vue-particles'
Vue.use(VueParticles)
Vue.use(VueTianditu, {
  v: "4.0", //目前只支持4.0版本
  tk: "47547b3dd13e715c7f45f1e6036d5124"
});
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import $ from 'jquery';
// 挂载到 window 上，使其全局可用
window.jQuery = $;
window.$ = $;

import axios from 'axios';
Vue.prototype.$axios = axios;
Vue.prototype.$baseUrl = baseUrl;
Vue.prototype.$api = api;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$delete = deletes;
Vue.prototype.$toJson = toJson;
Vue.prototype.$isEmpty = isEmpty;
Vue.prototype.$uploadImg = uploadImg;
Vue.prototype.$yuque = 'https://www.yuque.com/bocai007/zgqd2m/by15v96y65m9k5du';

Vue.config.productionTip = false;

// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})

let routerList = [];
let flag = 0;
let temdata = [];
let topLevelRouteAdded = false;

// 处理路由集合
function handlerRouters(list) {
  list.forEach(item => {
    if (item.component && item.path) {
      if (item.component !== '/application/cashierDesk/index'&&item.component!=='/orderManagement/orderOfCustom') {
        // 普通路由添加到routerList
        routerList.push({
          path: item.path,
          name: item.title,
          keepalive: item.keepalive,
          component: () => import(`@/views${item.component}`),
          meta: { requireAuth: true, keepalive: item.keepalive }
        });
      } else {
        // 特殊路由标记并保存
        flag = 1;
        temdata.push(item);
      }
    }
    if (item.child && item.child.length > 0) {
      handlerRouters(item.child);
    }
  });
}

// 重置路由并添加动态路由
function setupDynamicRoutes() {
  resetRouter();
  routerList = [];
  flag = 0;
  temdata = [];
  
  const menuList = JSON.parse(localStorage.getItem('menuList') || '[]');
  handlerRouters(menuList);
  
  // 先添加顶级特殊路由
  if (flag === 1 && !topLevelRouteAdded) {
    temdata.forEach(item => {
      router.addRoute({
        path: item.path,
        name: item.title,
        keepalive: item.keepalive,
        component: () => import(`@/views${item.component}`),
        meta: { requireAuth: true, keepalive: item.keepalive }
      });
    })
    topLevelRouteAdded = true;
  }
  
  // 再添加所有子路由到index
  routerList.forEach(item => {
    router.addRoute('index', item);
  });
}

// 初始化路由
setupDynamicRoutes();

// 路由拦截器
router.beforeEach((to, from, next) => {
  if (to.matched.length !== 0) {
    // 已有匹配路由，正常处理权限
    if (to.meta.requireAuth) {
      if (Boolean(localStorage.getItem("userdata_shop"))) {
        next();
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        });
      }
    } else {
      // 不需要权限的路由
      if (Boolean(localStorage.getItem("userdata_shop"))) {
        if (to.path !== "/" && to.path !== "/login") {
          next();
        } else {
          // 已登录但访问登录页或首页，可能需要重定向到默认页面
          next();
        }
      } else {
        next();
      }
    }
  } else {
    // 没有匹配路由，重新加载动态路由
    setupDynamicRoutes();
    next({
      path: to.path,
      query: to.query,
      replace: true
    });
    // next({
    //   path: '/login',
    //   query: {
    //     redirect: to.fullPath
    //   } // 将跳转的路由path作为参数，登录成功后跳转到该路由
    // })
  }
})
Vue.directive('havePermission',function(el,binding){
  if(JSON.parse(localStorage.getItem('ruleIds')).indexOf(binding.value[0])>-1){
    el.style.display=binding.value[1]
  }else{
    el.style.display='none'
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, //使用store vuex状态管理
  components: {
    App
  },
  template: '<App/>',
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  }

})


// WEBPACK FOOTER //
// ./src/main.js